import { styled } from "@stitches/react";
import { Label, Input, SingleSelect, Button, Modal } from "@/vendor/Forge/dist";
import { MultiselectChangeEvent, StructuredOption } from "@/vendor/Forge/dist";
import { ChangeEventHandler, MouseEventHandler } from "react";
import { useState } from "react";
import { useAddBucket } from "@/hooks/use-add-new-bucket";

const Wrapper = styled("div", {
    display: "flex",
    width: "100%",
    flexDirection: "column",

    "& .fe_c_button": {
        maxWidth: "30%",
        marginTop: "15px",
    }
});

const CreateBucketButtonWrapper = styled("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    marginTop: "15px",
  });

const BucketsWrapper = styled("div", {
    display: "flex",
    alignItems: "end",
    justifyContent: "center",
    marginTop: "15px",
    width: "100%",
});

const BucketsContainer = styled("div", {
    display: "flex",
    flexDirection: "column",
    width: "100%",
});

const PriorityContainer = styled("div", {
    display: "flex",
    flexDirection: "column",
    width: "33%",
    marginLeft: "30px",
});

interface Props {
    bucketList: string[];
    setBuckets: (value: string[]) => void;
    selectedBucket: string[];
    priority: string | undefined;
    setPriority: (value: string) => void;
}

const BucketAssignment = ({ bucketList, setBuckets, selectedBucket, setPriority, priority }: Props) => {
    const [modal, setModal] = useState(false);
    const [confirmationModal, setconfirmationModal] = useState(false);
    const [bucketName, setBucketName] = useState<string>();
    const handleSearch: ChangeEventHandler<HTMLInputElement> = (e) => {
        const value = e.target.value;
        setPriority(value);
    };
    const { addBucket, isPending } = useAddBucket();

    const newBucketSubmit: MouseEventHandler<HTMLButtonElement> = () => {
        showConfirmationModal();
    };

    const showConfirmationModal = () => {
        setModal(false);
        setconfirmationModal(true);
    };

    const newBucketConfirmationBanners = () => {
        setconfirmationModal(false);
        if (bucketName)
        addBucket({ bucketName: bucketName, isEnabled: true });
        // return setBannerElement(allBanners[0].banner);
    };

    const showBucketModal = () => {
        setModal(true);
    };

    return (
       <Wrapper>
            <BucketsWrapper>
                <BucketsContainer>
                    <Label aria-label="Existing Buckets" text="Existing Buckets" />
                    <SingleSelect
                        onChange={(event: MultiselectChangeEvent<StructuredOption, false>) => {
                            const selected = event.target.value;
                            return setBuckets([selected?.value as string]);
                        }}
                        aria-labelledby="Existing Buckets"
                        disabled={isPending}
                        options={bucketList}
                        value={selectedBucket[0]} />
                </BucketsContainer>
                <PriorityContainer>
                    <Label aria-label="Priority" text="Priority" />
                    <Input
                        aria-labelledby="Priority"
                        onChange={handleSearch}
                        value={priority}
                        />
                </PriorityContainer>
            </BucketsWrapper>
            <Button
                variant="secondary"
                onClick={showBucketModal}
                >Create New Bucket
            </Button>
            <Modal
                data-testid="bucket-modal"
                headerText="Add a New Bucket"
                primaryButtonText="Create New Bucket"
                show={modal}
                includeButtonRow={false}
                onPrimaryClick={newBucketSubmit}
                onHide={() => {
                setModal(false);
                setBucketName(undefined);
                } }
                onBackdropClick={()=>{
                setModal(false);
                setBucketName(undefined);
                }}>
                <p>Add New Bucket</p>
                <Input
                placeholder="Type"
                type="text"
                name="bucketName"
                data-testid="bucket-modal-input"
                onChange={(e) => setBucketName(e.target.value)}
                />
                <CreateBucketButtonWrapper>
                <Button variant="secondary" onClick={() => {
                    setModal(false);
                    setBucketName(undefined);
                    }}>Cancel</Button>
                <Button onClick={newBucketSubmit} disabled={bucketName == undefined}>Create New Bucket</Button>
                </CreateBucketButtonWrapper>
            </Modal>
            <Modal
                data-testid="confirmation-modal"
                headerText="Create A New Bucket?"
                alertType="attention"
                primaryButtonText="Create New Bucket"
                show={confirmationModal}
                onPrimaryClick={ newBucketConfirmationBanners }
                onHide={() => {
                setconfirmationModal(false);
                setBucketName(undefined);
                } }
                onBackdropClick={()=>{
                setconfirmationModal(false);
                setBucketName(undefined);
                }}>
                <p>Are you sure you want to add a new bucket?</p>
            </Modal>
       </Wrapper>
    );
};

export default BucketAssignment;
